import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONVENIOSEXECUCAODIRETA_PORT}${process.env.VUE_APP_API_PATH}/conveniosexecucaodireta`;
const urlBase = `${api}`;

export default {
    obterTodasReceitasReconhecidasPorReceitas(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidasporreceitas`);
    },

    obterPorFiltroReceitasReconhecidasPorReceitas(filtro) {
        return axiosJwt.get(`${urlBase}/${filtro.idCnt}/relatorios/receitas/relatoriosreceitasreconhecidasporreceitascomfiltro`, {
            params: filtro,
        });
    },

    obterTodasReceitasReconhecidasPorReceitasRelatorioComFiltro(filtro) {
        return axiosJwt.get(`${urlBase}/${filtro.idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidasporreceitasrelatoriocomfiltro`, {
            responseType: 'blob',
            params: filtro,
        });
    },
    obterTodasReceitasReconhecidasPorReceitasRelatorio(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/receitas/relatoriostodasreceitasreconhecidasporreceitasrelatorio`, {
            responseType: 'blob',
        });
    },
    obterRelatorioReceitaIndividual(idCnt, convenioReceitaId) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/receitas/individual/${convenioReceitaId}`, {
            responseType: 'blob',
        });
    },

    obterRelatorioConsolidado(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/receitas/consolidado`, {
            responseType: 'blob',
        });
    },
};
